import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DefaultDataServiceConfig, HttpUrlGenerator } from '@ngrx/data';
import { Store } from '@ngrx/store';
import { LoggingService } from '../../../shared/services/logging/logging.service';
import { EfaactDynamicDataService } from '../../efaact.dynamic-data-service';
import { Accrual } from './accrual.model';

export const entityName = 'empleavegraph';

@Injectable()
export class AccrualDataService extends EfaactDynamicDataService<Accrual> {
    constructor(
        http: HttpClient,
        httpUrlGenerator: HttpUrlGenerator,
        log: LoggingService,
        config: DefaultDataServiceConfig,
        store: Store
    ) {
        super(
            http,
            httpUrlGenerator,
            entityName,
            log,
            { ...config, root: `${config.root}/dashboard` },
            store
        );
    }

    mapItems(item: Accrual): Accrual {
        if (!item) {
            return;
        }
        return {
            ...item,
            id: item.PPE
        };
    }
}
